import { Card, Stack } from '@mui/material';
import {
    CreateButton,
    ListBase,
    ListToolbar,
    Pagination,
    SortButton,
    Title,
    TopToolbar,
    useGetIdentity,
    useListContext,
} from 'react-admin';

import { LeadEmpty } from './LeadEmpty';
import { LeadListContent } from './LeadListContent';
import { LeadListFilter, LEAD_OPEN_STATUS_FILTER } from './LeadListFilter';

export const LeadList = () => {
    const { identity } = useGetIdentity();
    if (!identity) return null;

    return (
        <ListBase
            disableAuthentication
            perPage={25}
            sort={{ field: 'id', order: 'DESC' }}
            filterDefaultValues={LEAD_OPEN_STATUS_FILTER}
        >
            <LeadListLayout />
        </ListBase>
    );
};

const LeadListLayout = () => {
    const { data, isPending, filterValues } = useListContext();
    const { identity } = useGetIdentity();
    const hasFilters = Object.keys(filterValues || {}).length > 0;

    return (
        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ width: '100%' }}>
            <LeadListFilter />
            <Stack sx={{ width: '100%', minWidth: 0, flex: 1 }}>
                <Title title="Leads" />
                <ListToolbar actions={<LeadListActions />} />
                {!identity || isPending ? null : !data?.length && !hasFilters ? (
                    <LeadEmpty />
                ) : (
                    <>
                        <Card>
                            <LeadListContent />
                        </Card>
                        <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
                    </>
                )}
            </Stack>
        </Stack>
    );
};

const LeadListActions = () => (
    <TopToolbar>
        <SortButton fields={['name', 'id', 'created_at', 'status']} />
        <CreateButton variant="contained" label="New lead" sx={{ marginLeft: 2 }} />
    </TopToolbar>
);
